export type Group = {
  groupId: string;
  displayName: string;
  description: string;
  photoUrl: string;
  adminIds: string[];
  createdAt: Date;
  updatedAt: Date;
  verified?: boolean;
  numMembers?: number;
};

export type GroupFormData = Pick<Group, 'displayName' | 'description' | 'photoUrl' | 'adminIds'>;
